import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const  checkRouter: Array<RouteRecordRaw> = [
    {
        path: '/check',
        name: '审核管理',
        component: Layout,
        redirect: '/check/product-list',
        meta: { title: '审核管理', icon: 'icon-invoice', alwaysShow: true },
        children: [
            {
                path: 'product-list',
                name: '商品审核',
                component: () => import('@/views/check/ProductList.vue'),
                meta: { title: '商品审核', keepAlive: true, depth: 30, badge: 'unCheckProduct' }
            },
            {
                path: 'product-list-old',
                name: '商品审核-旧',
                component: () => import('@/views/check/ProductListOld.vue'),
                meta: { title: '商品审核-旧', keepAlive: true, depth:30 }
            },
            {
                path: 'product-edit',
                name: '商品审核详情',
                component: () => import('@/views/merchant-admin/ProductEdit.vue'),
                meta: { title: '商品审核详情', depth: 40 }
            },
            {
                path: 'second-brand-list',
                name: '二级品牌审核',
                component: () => import('@/views/check/SecondBrandList.vue'),
                meta: { title: '二级品牌审核', keepAlive: true, depth:30, badge: 'two_brand' }
            },
            {
                path: 'second-brand-edit',
                name: '二级品牌审核详情',
                component: () => import('@/views/merchant-admin/SecondBrandEdit.vue'),
                meta: { title: '二级品牌审核详情', depth: 40 }
            },
            {
                path: 'recharge-list',
                name: '充值审核列表',
                component: () => import('@/views/check/RechargeList.vue'),
                meta: { title: '充值审核列表', keepAlive: true, depth:30, badge: 'sgcc_recharges' }
            },
            {
                path: 'coupon-list',
                name: '用户发码列表',
                component: () => import('@/views/check/CouponList.vue'),
                meta: { title: '用户发码列表', keepAlive: true, depth:30 }
            },
            {
                path: 'appeal-list',
                name: '申诉审核列表',
                component: () => import('@/views/check/AppealList.vue'),
                meta: { title: '申诉审核列表',keepAlive: true, depth:30, badge: 'fine_appeal' }
            },
            {
                path: 'appeal-edit',
                name: '申诉审核编辑',
                component: () => import('@/views/check/AppealCheck.vue'),
                meta: { title: '申诉审核编辑' }
            },
            {
                path: 'delivery-list',
                name: '运费审核列表',
                component: () => import('@/views/check/DeliveryList.vue'),
                meta: { title: '运费审核列表', keepAlive: true, depth:30, badge: 'freight_examine' }
            },
            {
                path: 'shop-list',
                name: '门店审核列表',
                component: () => import('@/views/check/ShopList.vue'),
                meta: { title: '门店审核列表',  keepAlive: true, depth:30, badge: 'shops_approval' }
            },
            {
                path: 'spring-rule-list',
                name: '配规审核',
                component: () => import('@/views/merchant-admin/SpringRuleList.vue'),
                meta: { title: '配规审核',  
                        v: 2,   // 运营端
                        keepAlive: true, depth:30,badge: 'cj_distribution_rule' }
            },
            {
                path: 'special-rule-list',
                name: '特殊配规审核列表',
                component: () => import('@/views/merchant-admin/special-rules/SpecialRuleList.vue'),
                meta: { title: '特殊配规审核', v: 2, keepAlive: true, depth:30 }
            },
            {
                path: 'special-rule-edit',
                name: '特殊配规审核编辑',
                component: () => import('@/views/merchant-admin/special-rules/SpecialRuleEdit.vue'),
                meta: { title: '特殊配规审核编辑', v: 2, depth: 40 }
            },
            {
                path: 'rating-edit',
                name: '客诉审核编辑',
                component: () => import('@/views/check/RatingAppealCheck.vue'),
                meta: { title: '客诉审核编辑' }
            },
            {
                path: 'activity-list',
                name: '运营活动审核',
                component: () => import('@/views/check/ActivityList.vue'),
                meta: { title: '活动审核' }
            },
            {
                path: 'product-view',
                name: '运营查看商品',
                component: () => import('@/views/merchant-admin/ActiveProductList.vue'),
                meta: { title: '查看商品' }
            }
        ]
    }
]

export default  checkRouter